import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-901259b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "medical-records-collect-wrapper w-100 mb-15" }
const _hoisted_2 = {
  key: 0,
  class: "row row-cols-auto gx-10 gy-8 gy-md-0 mw-xl-75 mx-lg-auto align-items-stretch"
}
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = {
  role: "button",
  for: "no_records",
  class: "radio-btn d-flex align-items-center px-5 py-7 text-wrap h-100"
}
const _hoisted_5 = { class: "label-main fw-bolder mb-2" }
const _hoisted_6 = { class: "label-description fw-normal" }
const _hoisted_7 = { class: "col-12 col-md-6" }
const _hoisted_8 = {
  role: "button",
  for: "has_records",
  class: "radio-btn d-flex align-items-center px-5 py-7 text-wrap h-100"
}
const _hoisted_9 = { class: "label-main fw-bolder mb-2" }
const _hoisted_10 = { class: "label-description fw-normal" }
const _hoisted_11 = { class: "selected-status-content d-flex flex-column align-items-center mt-12" }
const _hoisted_12 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionnaireSignUp = _resolveComponent("QuestionnaireSignUp")!
  const _component_QuestionnaireResultWrapper = _resolveComponent("QuestionnaireResultWrapper")!

  return (_openBlock(), _createBlock(_component_QuestionnaireResultWrapper, {
    header: _ctx.$t('Find the best clinical trials'),
    description: $setup.description
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.showStatusOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    class: "radio-custom me-6",
                    type: "radio",
                    id: "no_records",
                    value: "no_records",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedStatus) = $event))
                  }, null, 512), [
                    [_vModelRadio, $setup.selectedStatus]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(`d-flex flex-column ${
                  $setup.selectedStatus === 'no_records' ? 'selected' : ''
                }`)
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("I do not have medical records")), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(
                    "We can obtain your medical records with the information provided by you"
                  )), 1)
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    class: "radio-custom me-6",
                    type: "radio",
                    id: "has_records",
                    value: "has_records",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedStatus) = $event))
                  }, null, 512), [
                    [_vModelRadio, $setup.selectedStatus]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(`d-flex flex-column ${
                  $setup.selectedStatus === 'has_records' ? 'selected' : ''
                }`)
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("I have medical records")), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(
                    "I can upload my medical records by signing up Massive Bio Patient Portal"
                  )), 1)
                  ], 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            (_openBlock(), _createBlock(_resolveDynamicComponent($setup.noMedicalRecordContent.component), _mergeProps({ class: "m-auto" }, _toHandlers($setup.noMedicalRecordContent.event)), null, 16))
          ], 512), [
            [_vShow, $setup.selectedStatus === 'no_records']
          ]),
          _withDirectives(_createVNode(_component_QuestionnaireSignUp, { onSubmitForm: $setup.onSubmitRegister }, null, 8, ["onSubmitForm"]), [
            [_vShow, $setup.selectedStatus === 'has_records']
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["header", "description"]))
}